import React, { useState } from "react";
import { Card } from "@fdoh/health-ui-react";
import DataTable from "react-data-table-component";
import { genericFilter } from "../helpers/genericFilter";
import { ColumnSetting, IndexCardProps } from "./IndexCard.types";
import { style } from "./dataTableStyle";

export const IndexCard = <T extends {}>(props: IndexCardProps<T>) => {
  const { buttons, noFilter, data, title, ...dataTableProps } = props;
  const tableRowSettingName = `${props.name}_rowsPerPage`;
  const [filterText, setFilterText] = useState<string>("");

  // Get rowsPerPage from localstorage or set to default from props or 10
  const getRowsPerPage = () => {
    let x = Number(localStorage.getItem(tableRowSettingName));
    return x === 0 ? props.paginationRowsPerPageOptions ?? 10 : x;
  };

  const setRows = (rows: number, currentPage: number) => {
    localStorage.setItem(tableRowSettingName, rows.toString());
    setRowsPerPage(rows);
  };

  const [rowsPerPage, setRowsPerPage] = useState<number>(getRowsPerPage);

  const {
    defaultSortAsc = true,
    defaultSortField = "id",
    dense = true,
    noHeader = true,
    pagination = true,
    responsive = true,
    striped = true,
  } = dataTableProps;

  const filtered = genericFilter(
    data,
    props.columns,
    filterText.toLocaleLowerCase()
  );

  const NoDataComponent = ({ columns }: { columns: ColumnSetting<T>[] }) => {
    return (
      <table className="table table-vcenter">
        <thead>
          <tr>
            {columns.map((x) => (
              <th>{x.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={columns.length} className="text-center">
              - Empty -
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <Card.Container>
      <Card.Header>
        <Card.Title>{title}</Card.Title>
        <Card.HeaderButtonGroup>
          {!noFilter && (
            <li className="nav-item ms-auto print-hide">
              Search:
              <div className="ms-2 d-inline-block">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  aria-label="Search pools"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </li>
          )}
          {buttons}
        </Card.HeaderButtonGroup>
      </Card.Header>
      <div className="table-responsive">
        <DataTable
          {...dataTableProps}
          className="datatable"
          //customStyles={style}
          data={filtered ?? []}
          noDataComponent={<NoDataComponent columns={dataTableProps.columns} />}
          progressPending={!data}
          progressComponent={<Card.Skeletons title="Loading..." />}
          paginationPerPage={rowsPerPage}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
          noHeader={noHeader}
          pagination={pagination}
          defaultSortField={defaultSortField}
          defaultSortAsc={defaultSortAsc}
          responsive={responsive}
          striped={striped}
          dense={dense}
          onChangeRowsPerPage={setRows}
        />
      </div>
    </Card.Container>
  );
};

export default IndexCard;
